export default __webpack_public_path__ + "static/media/masterwook.bdfb4e39.png";